<template>
  <div :class="{ active: show }" class="modal">
    <div v-if="modal">
      <span class="survey-name"
        >{{ modal.nameSurvey }} - {{ parseTranslation(COPY) }}</span
      >

      <form
        method="post"
        @submit.prevent="upload($event)"
        action="/survey"
        enctype="multipart/form-data"
      >
        <input
          :placeholder="translations[language][PLACEHOLDER_SURVEY_NAME]"
          type="text"
          name="surveyname"
          v-model="name"
          @keyup="validateName('#name')"
        />

        <select name="lang" v-model="surveyLanguage" required>
          <option disabled selected value="">{{
            translations[language][LANGUAGE]
          }}</option>
          <option value="pt">{{ parseTranslation(LANGUAGE_PORTUGUESE) }}</option>
          <option value="es">{{ parseTranslation(LANGUAGE_SPANISH) }}</option>
          <option value="en">{{ parseTranslation(LANGUAGE_ENGLISH) }}</option>
        </select>

        <select name="type" v-model="type" required>
          <option disabled selected value="">{{ parseTranslation(TYPE) }}</option>
          <option value="CAWI">CAWI</option>
          <option value="CATI">CATI</option>
          <option value="CAPI">CAPI</option>
        </select>

        <div class="buttons">
          <button @click.prevent="closeModal()">
            {{ parseTranslation(CANCEL) }}
          </button>

          <button type="submit" @click.prevent="createClone(modal.rowId)">
            <span v-if="loader"><Loader color="#fff"/></span>
            <span v-else>{{ parseTranslation(CREATE) }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/loading/Loader-3'

import { mapActions } from 'vuex'

import * as translationAddPartner from './ModalClone.translations'
const { default: translations, ...translationKeys } = translationAddPartner

export default {
  components: {
    Loader,
  },

  data() {
    return {
      translations,
      ...translationKeys,
      uploadText: 'Upload File',
      loader: false,
      show: false,
      surveyLanguage: '',
      name: '',
      type: '',
    }
  },
  computed: {
    modal() {
      return this.$store.getters.modalClone
    },
  },
  watch: {
    modal() {
      if (this.modal) {
        this.openModal()
      }
    },
  },
  methods: {
    ...mapActions([
      'surveyRegister',
      'sendMessage',
      'executeSurveyAPICall',
      'modalClone',
    ]),

    openModal() {
      this.show = true
    },

    closeModal() {
      this.show = false

      this.modalClone(null)
    },

    validateName(element) {
      document.querySelector(element).value = document
        .querySelector(element)
        .value.replace(/\\/g, '')
    },

    async createClone(rowId) {
      if (this.loader) return

      this.loader = true

      const invalidFilling = !this.name || !this.surveyLanguage || !this.type

      if (invalidFilling) {
        return (
          this.sendMessage(this.parseTranslation(this.REQUIRED_FIELDS)),
          (this.loader = false)
        )
      }

      const newSurvey = await this.executeSurveyAPICall({
        method: 'POST',
        path: 'survey',
        payload: {
          lang: this.surveyLanguage,
          name: this.name,
          type: this.type,
          clone_sid: rowId,
        },
      })

      if (!newSurvey) return (this.loader = false)

      this.surveyLanguage = ''
      this.name = ''
      this.type = ''

      this.surveyRegister(newSurvey)

      await this.$router.push(`/${newSurvey.step}`)

      this.closeModal()

      this.loader = false
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  @include background-modal-config;

  &.active {
    display: flex;
  }

  > div {
    @include modal-config(700);

    .survey-name {
      @include tipography(18);
      text-transform: uppercase;

      .light & {
        color: $main-two;
      }
    }

    form {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 40px;

      input {
        margin-right: 30px;
        flex: 1;
        min-width: 300px;

        &::placeholder {
          color: $white;
        }

        .light &::placeholder {
          color: $gray-6;
        }
      }

      input,
      select {
        @include tipography(16);
        color: $white;
        background: none;
        border: 1px solid $white;
        padding: 8px 10px;
        border-radius: 3px;
        height: 40px;

        &:focus {
          outline: none;
        }

        .light & {
          color: $gray-6;
          border-color: $gray-5;
        }
      }

      select {
        color: $white;

        option {
          color: $gray-6;
        }

        &:nth-of-type(1) {
          margin-right: 30px;
        }

        .light & {
          color: $gray-6;
        }
      }

      .buttons {
        margin-top: 30px;
        display: flex;

        button {
          @include modal-buttons;
        }
      }
    }
  }
}

@media (max-width: 768.98px) {
  .modal {
    > div {
      form {
        justify-content: center;
        flex-direction: column;

        input {
          margin-right: 0;
        }

        select {
          margin-top: 15px;

          &:nth-of-type(1) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>
